export function dataBR() {
  const dataCSV = document.querySelector("#data").value;
  const data = new Date(dataCSV);
  const dataDeExportacao = new Date(data.setDate(data.getDate() + 1));
  const dataExpCSV = dataDeExportacao.toLocaleDateString();
  return dataExpCSV;
}
